import { render, staticRenderFns } from "./BusinessAnnualReturnsApplications.vue?vue&type=template&id=3bb30bc2&scoped=true&"
import script from "./BusinessAnnualReturnsApplications.vue?vue&type=script&lang=js&"
export * from "./BusinessAnnualReturnsApplications.vue?vue&type=script&lang=js&"
import style0 from "./BusinessAnnualReturnsApplications.vue?vue&type=style&index=0&id=3bb30bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb30bc2",
  null
  
)

export default component.exports